import {
  MetamodelComponentTypeContext,
  MetamodelContextSettings,
} from 'metamodel/types';
import { APIFieldAttributes, Metamodel } from '@ardoq/api-types';
import {
  ComponentTypeSubtitle,
  ReferenceCompletionForComponent,
} from 'metamodel/metamodelStats/atoms';
import { BreadCrumbNavigation } from './breadCrumbNavigation/BreadCrumbNavigation';
import { getFieldCompletion } from './utils';
import { FieldCompletionWidget } from './completion/FieldCompletionWidget';
import { WorkspaceNavigationTitle } from './workspaceNavigationTitle/WorkspaceNavigationTitle';
import { Box } from '@ardoq/layout';
import { type I18nLocale } from '@ardoq/i18n';
import { type Locale } from '@ardoq/locale';

const ComponentTypeStats = ({
  context,
  metamodel,
  nonTemplateFieldsByName,
  locale,
  i18nLocale,
}: {
  context: MetamodelComponentTypeContext & MetamodelContextSettings;
  metamodel: Metamodel;
  nonTemplateFieldsByName: Map<string, APIFieldAttributes>;
  locale: Locale;
  i18nLocale: I18nLocale;
}) => {
  const content = metamodel.metamodel;
  const componentType = content.componentTypes[context.id];
  const componentFieldCompletion = getFieldCompletion(
    componentType,
    metamodel.metamodel.dateRangeFieldMap,
    nonTemplateFieldsByName
  );
  return (
    <Box position="relative">
      <BreadCrumbNavigation
        metamodel={metamodel}
        context={context}
        nonTemplateFieldsByName={nonTemplateFieldsByName}
      />
      <Box marginTop="small">
        <WorkspaceNavigationTitle
          metamodel={metamodel}
          context={context}
          i18nLocale={i18nLocale}
        >
          {context.name}
        </WorkspaceNavigationTitle>
      </Box>
      <ComponentTypeSubtitle
        fieldCompletion={componentFieldCompletion}
        i18nLocale={i18nLocale}
      />
      <ReferenceCompletionForComponent
        metamodel={metamodel}
        context={context}
        locale={locale}
        i18nLocale={i18nLocale}
      />
      <FieldCompletionWidget
        fieldCompletion={componentFieldCompletion}
        context={context}
        metamodel={metamodel}
        i18nLocale={i18nLocale}
      />
    </Box>
  );
};

export { ComponentTypeStats };
